import { Box, Card, CardContent, Link, Stack, Typography } from "@mui/material";
import ScheduleIcon from "@mui/icons-material/Schedule";

/**
 * Stub renderer for shell-only Access tabs. Renders a small centered
 * card with the tab name, a one-line rationale, and (where useful) a
 * link to the backing Jira / CLI so the operator can move forward via
 * a different surface while the UI is being built.
 */

const SLUGS = {
  invitations: {
    title: "Invitations",
    rationale:
      "Invite dialog + copy-once redemption UI are being wired up. Backend is ready.",
    href: "https://clue2solve.atlassian.net/browse/SCK-460",
    linkLabel: "SCK-460 (invite CLI)",
    cliHint: "c2a user invite -e teammate@example.com -s GOOGLE -P <project> -r CONTRIBUTOR",
  },
  roles: {
    title: "Roles",
    rationale:
      "Permission matrix + role catalog reference. Ships alongside the guards enforcement phase.",
    href: "https://clue2solve.atlassian.net/browse/SCK-467",
    linkLabel: "SCK-467 (permission matrix)",
  },
  sso: {
    title: "SSO",
    rationale:
      "Operator-provisioned in v1. Self-serve SSO / SAML config lands after 5 SSO accounts.",
    href: "https://clue2solve.atlassian.net/browse/SCK-462",
    linkLabel: "SCK-462 (Access Epic)",
  },
  audit: {
    title: "Audit log",
    rationale:
      "Role decisions logged when @RequireRole ships. This tab lights up when the audit endpoint lands.",
    href: "https://clue2solve.atlassian.net/browse/SCK-469",
    linkLabel: "SCK-469 (@RequireRole)",
  },
};

export default function AccessComingSoon({ slug }) {
  const meta = SLUGS[slug] || {
    title: slug,
    rationale: "Coming soon.",
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
      <Card
        variant="outlined"
        sx={{
          maxWidth: 520,
          width: "100%",
          borderStyle: "dashed",
          background: "transparent",
        }}
      >
        <CardContent sx={{ py: 4, px: 4 }}>
          <Stack spacing={2} alignItems="flex-start">
            <ScheduleIcon
              fontSize="large"
              sx={{ color: "text.secondary", opacity: 0.7 }}
            />
            <Typography variant="h6" component="h2" sx={{ fontWeight: 700 }}>
              {meta.title}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              {meta.rationale}
            </Typography>
            {meta.cliHint && (
              <Box
                component="pre"
                sx={{
                  m: 0,
                  mt: 1,
                  width: "100%",
                  p: 1.5,
                  borderRadius: 1,
                  background: "rgba(127,127,127,0.08)",
                  border: "1px solid",
                  borderColor: "divider",
                  fontFamily:
                    '"JetBrains Mono", "SF Mono", ui-monospace, monospace',
                  fontSize: 12.5,
                  overflowX: "auto",
                  whiteSpace: "pre",
                }}
              >
                {meta.cliHint}
              </Box>
            )}
            {meta.href && (
              <Link
                href={meta.href}
                target="_blank"
                rel="noreferrer"
                sx={{ fontSize: 13.5 }}
              >
                {meta.linkLabel} →
              </Link>
            )}
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
